import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "TMS for Sheriff's Deputies | Neuro Wellness TMS",
  description:
    "Sheriff's deputies: learn about TMS therapy, SAINT TMS, and mental health treatment options for depression, anxiety, and PTSD in Coral Springs, FL.",
  canonical: "/tms-for-sheriffs-deputies",
  keywords:
    "TMS for sheriff's deputies, sheriff deputy depression treatment, law enforcement TMS Florida, sheriff deputy PTSD treatment",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  { title: "TMS for Police Officers", href: "/tms-for-police-officers" },
  {
    title: "Depression Treatment for First Responders",
    href: "/depression-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
];

export default function TmsForSheriffsDeputies() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Sheriff's Deputies"
      title="TMS for Sheriff's Deputies"
      subtitle="Sheriff's deputies face the same trauma exposure as other law enforcement, often with added jail and court duties. If medication hasn't helped, there are other options."
    >
      <DecisionSection heading="What sheriff's deputies experience">
        <p>
          Sheriff's deputies handle patrol duties, court security, and jail
          operations — each with its own stressors. Jail environments in
          particular expose deputies to repeated crises, mental health
          emergencies, and confrontations. Over years, the cumulative weight
          contributes to depression, anxiety, and PTSD at rates higher than the
          general population.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared, non-invasive, outpatient",
            "SAINT accelerated TMS — five-day protocol, FDA-cleared",
            "SPRAVATO (esketamine) — FDA-approved for treatment-resistant depression",
            "Prism for PTSD — EEG neurofeedback for PTSD symptoms",
            "IV ketamine and KAP",
            "Trauma-informed psychotherapy",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Confidentiality and insurance">
        <p>
          Your treatment is confidential. We do not contact your sheriff's
          office or employer without your consent. Our team verifies your
          insurance benefits and handles authorization.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
